<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} Loyalty</div>
      <div>
        <router-link class="btn-blue" to="edit-loyalty">{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="loyalty">Loyalty {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div
            v-for="(loyaltyDetail, loyaltyDetailIndex) in loyaltyDetails"
            :key="loyaltyDetailIndex"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-lg-3">{{ loyaltyDetailIndex }}</div>
              <div class="col-lg-9">{{ loyaltyDetail[loyaltyDetailIndex] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      loyaltyDetails: {
        selected_Cinema: "PVR Andheri",
        LoyaltyType: "CRUD",
        Level: "Level 1",
        Minimum_Points_For_Redemption: 200,
        Requirement_To_Enroll: "Mobile No",
        Eligibility:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo nulla maxime odit dolorem fuga vel deleniti laborum. Excepturi exercitationem accusantium aliquid numquam nisi, nobis explicabo sed distinctio maiores! Saepe, sint."
      }
    };
  }
};
</script>
 



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltyComponent/viewLoyalty.vue